import {useState, useCallback} from 'react';

/**
 * Custom hook for managing toast notifications
 * @returns {object} - { toasts, showToast, removeToast }
 */
export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    const newToast = {id, message, type, duration};
    
    setToasts(prev => [...prev, newToast]);
    
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  return {toasts, showToast, removeToast};
};
